<template>
  <div class="list">
    <state-loading v-if="isLoading" />
    <template v-else-if="activityList && activityList.length">
      <div
        v-for="(item, index) in activityList"
        :key="index"
        class="list-item"
        @click="onClickActivity(item)"
      >
        <img :src="item.operateImage" alt="" class="list-item-img" />
        <div class="list-item-title">{{ item.operateActivityName }}</div>
      </div>
    </template>
    <div v-else class="list-nodata">暂无数据</div>
  </div>
</template>

<script>
import { setTitle } from '@/utils';
import StateLoading from '../../components/state-loading/index.vue'
import { getActivityList } from './api/activity-list'
import { OPERATE_TYPE } from './handler/const'

export default {
  components: {
    StateLoading
  },
  data() {
    return {
      OPERATE_TYPE,
      activityList: [],
      isLoading: false
    }
  },
  computed: {
    cityId() {
      return this.$AppService.getCityId()
    }
  },
  mounted() {
    this.requestActivityList()
  },
  activated() {
    setTitle('活动专区')
    this.requestActivityList()
  },
  deactivated() {
    this.$HomeService.fetchConfig({ cityId: this.cityId }).then((res) => {
      const { pageTitle } = res || {}
      setTitle(pageTitle)
    }).catch(() => {
      setTitle()
    })
  },
  methods: {
    requestActivityList() {
      this.isLoading = true
      return getActivityList({ bigCityId: this.cityId })
        .then(res => {
          this.activityList = res.sort((a, b) => a.displayOrder - b.displayOrder)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    // 点击活动
    onClickActivity(info) {
      console.log('info', info)
      if (info.operateType === OPERATE_TYPE.USER_SHARE) {
        this.$router.push({
          name: 'activityInvite',
          query: {
            cityId: this.cityId,
            operateActivityId: info.operateActivityId
          }
        })
      } else {
        const { operateRelated } = info || {}
        if (!operateRelated) return
        const operateRelatedList = JSON.parse(operateRelated)
        if (!operateRelatedList || !operateRelatedList.length) return
        const activityId = operateRelatedList[0].activityId
        const proUrl = `https://maas.chelaile.net.cn/customization-coupon/#/response-bus`
        const devUrl = `https://dev.maas.chelaile.net.cn/customization-coupon/#/response-bus`
        const url = process.env.VUE_APP_ENV === 'production' ? proUrl : devUrl
        let params = `cityId=${this.cityId}&activityId=${activityId}&operateActivityId=${info.operateActivityId}`
        const {mobile} = this.$UserService.getUser() || {}
        if (mobile) {
          params += `&mobile=${mobile}`
        }
        window.location.href = `${url}?${params}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  min-height: 100%;
  background: #fff;
  padding: 17px;
  &-item {
    height: 99px;
    margin-bottom: 17px;
    position: relative;
    display: flex;
    align-items: center;
    &-img {
      position: absolute;
      width: 100%;
      height: 100%;
    }
    &-title {
      position: relative;
      font-size: 26px;
      font-weight: 500;
      color: #ffffff;
      line-height: 33px;
      letter-spacing: 1px;
      margin-left: 10px;
    }
  }
  &-nodata {
    font-size: 16px;
    color: #333;
    text-align: center;
  }
}
</style>
